import { Head, Link, usePage } from "@inertiajs/react";
import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import AppLayout from "@/layouts/app-layout";
import {
  newOrganizationPurchaseRequestPath,
  organizationPurchaseRequestsPath,
} from "@/routes";
import type {
  BreadcrumbItem,
  Company,
  PagyMetadata,
  PurchaseRequest,
  RansackFilters,
  SharedData,
} from "@/types";

import { PurchaseRequestsDataTable } from "./data-table";

interface PurchaseRequestsProps {
  data: {
    purchase_requests: PurchaseRequest[];
    pagy: PagyMetadata;
  };
  filters: RansackFilters;
  companies: Company[];
}

export default function PurchaseRequests({
  data,
  filters,
  companies,
}: PurchaseRequestsProps) {
  const { purchase_requests, pagy } = data;
  const { auth } = usePage<SharedData>().props;
  const organizationSlug = auth.current_organization?.slug ?? "";
  const purchaseRequestsHref =
    organizationPurchaseRequestsPath(organizationSlug);
  const breadcrumbs: BreadcrumbItem[] = [
    {
      title: "Solicitudes Compras",
      href: purchaseRequestsHref,
    },
  ];

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Solicitudes Compras" />
      <div className="flex h-full flex-1 flex-col gap-4 p-4">
        <div className="flex flex-col space-y-2">
          <h2 className="text-2xl font-bold">Solicitudes de Compras</h2>
          <p className="text-muted-foreground">
            Gestiona las solicitudes de compra y sus cotizaciones
          </p>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Total: {pagy.count} solicitudes
          </div>
          <Button asChild>
            <Link href={newOrganizationPurchaseRequestPath(organizationSlug)}>
              <Plus />
              Nueva Solicitud
            </Link>
          </Button>
        </div>

        <PurchaseRequestsDataTable
          purchaseRequests={purchase_requests}
          pagy={pagy}
          filters={filters}
          companies={companies}
        />
      </div>
    </AppLayout>
  );
}
